import { render, staticRenderFns } from "./signaturePage.vue?vue&type=template&id=6250116c&scoped=true&"
import script from "./signaturePage.vue?vue&type=script&lang=ts&"
export * from "./signaturePage.vue?vue&type=script&lang=ts&"
import style0 from "./signaturePage.vue?vue&type=style&index=0&id=6250116c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6250116c",
  null
  
)

export default component.exports